import React, { useState } from 'react';
import { Link } from '@printdeal/ui-library';
import { FormattedMessage } from 'react-intl';
import { addDataLayerEntry } from '@printdeal/data-layer-manager';
import {
  recentOrderEvents,
  recentOrderMessages,
} from './RecentOrderHelper';
import ReOrderModal from '../../my-account/components/shared/Actions/ReOrderAction/ReOrderModal';
import { SanitizedLineItem, SanitizedOrder } from '../../../types/order/Order';

interface Props {
  lineItem: SanitizedLineItem;
  order: SanitizedOrder;
  position: string;
  stateName: string | undefined;
}

export const RecentOrderReOrderLink = ({
  lineItem, order, position, stateName,
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleAddToCartClick = () => {
    setIsModalOpen(true);
    addDataLayerEntry(
      recentOrderEvents.RECENT_ORDER_CLICK,
      {
        position,
        button: 're_order',
        stateName,
      },
    );
  };

  return (
    <div className="pd-sr-only lg:pd-not-sr-only">
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link
        as="button"
        variant="secondary"
        type="submit"
        iconBefore="refresh"
        onClick={handleAddToCartClick}
      >
        <FormattedMessage
          id={recentOrderMessages.recentOrderReOrderLink.id}
          defaultMessage={recentOrderMessages.recentOrderReOrderLink.defaultMessage}
        />
      </Link>
      {
        isModalOpen && (
          <ReOrderModal
            lineItems={[lineItem]}
            order={order}
            handleCloseModal={handleCloseModal}
          />
        )
      }
    </div>
  );
};
